import React, { useEffect } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import { useState } from "react";
import { Link } from "react-router-dom";
import "../View/Card_view/cardView.css";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import {
  setKey,
  setDefaults,
  setLanguage,
  setRegion,

  fromLatLng,

  geocode,
  RequestType,
} from "react-geocode";

const containerStyle = {
  width: "100%",
  height: "856px",
};

const MapComponent = ({
  property,
  propertyLoading,
  like,
  unlike,
  hidden,
  label,setPropertyId, propertyId,setCountry,setFilteredProperty,filteredProperty
}) => {
  const [viewProp, setViewProp] = useState();
 const[createdMarkers,setCreatedMarkers]=useState([])

 const[map,setMap]=useState(null)
  const mapRef = React.useRef(null);
  const location = useLocation();
  const { frontLabelsName } = label;
  setKey("AIzaSyCb1YPbyCqwlT6XLU83s9UqZViwzEtXRzc"); ///here put api key 
  setLanguage("en");
  setRegion("IS");
  useEffect(()=>{
    if(propertyId){
      setViewProp(property?.find((val) => val._id === propertyId));
    }
  },[propertyId])


 const onMarkerDragEnd=(e)=>{
  var bounds = map?.getBounds()
      let tempArr = []


      createdMarkers.filter((e)=>bounds && bounds.contains(e.getPosition())).forEach((k)=>{
        property.filter((t)=>t.lat == k.getPosition().lat() && t.lng == k.getPosition().lng()).forEach((l)=>{
          tempArr.push(l);
        })
      })
   
      setFilteredProperty(tempArr)
 }


  function handleZoomChanged() {



    // Create some markers
 

      var bounds = map?.getBounds()
      let tempArr = []


      createdMarkers.filter((e)=>bounds && bounds.contains(e.getPosition())).forEach((k)=>{
        property.filter((t)=>t.lat == k.getPosition().lat() && t.lng == k.getPosition().lng()).forEach((l)=>{
          tempArr.push(l);
        })
      })
   
      setFilteredProperty(tempArr)
   

                    
    // for (var i = 0; i < createdMarkers?.length; i++) {
    //     var marker = createdMarkers[i]
    
                                           
    //     if(bounds.contains(marker.getPosition())===true) {

    //      console.log(marker.getPosition().lat(),marker.getPosition().lng())
    //     }
      
    // }
     
 
    // let lati=mapRef?.current?.center?.lat()
    // let longi=mapRef?.current?.center?.lng()
   
    // fromLatLng(lati, longi).then(
    //   response => {
    
    //     let country =  response.results.filter((t)=>t.types.indexOf('country') !== -1)[0].formatted_address
    //     setCountry(country)
    //   })
  
  }


  const getPropertyType = (val) => {
    if (val?.length > 0) {
      let label;
      if (val?.includes("1") && val?.includes("2") && val?.includes("3")) {
        label = "Rental, Sale, PG";
      } else if (val?.includes("1") && val?.includes("2")) {
        label = "Rental, Sale";
      } else if (val?.includes("2") && val?.includes("3")) {
        label = "Sale, PG";
      } else if (val?.includes("3") && val?.includes("1")) {
        label = "Rental, PG";
      } else if (val?.includes("1")) {
        label = "Rental";
      } else if (val?.includes("2")) {
        label = "Sale";
      } else {
        label = "PG";
      }
      return label;
    }
  };

  const getTypeName = (val) => {
    if (val === "detachedHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_detached_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_detached_house")[0][
          "value"
          ] || "lbl_detached_house"
          : "lbl_detached_house"
        : "lbl_detached_house";
    } else if (val === "duplex") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_duplex").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_duplex")[0]["value"] ||
          "lbl_duplex"
          : "lbl_duplex"
        : "lbl_duplex";
    } else if (val === "tripleAptHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house")[0][
          "value"
          ] || "lbl_triple_apt_house"
          : "lbl_triple_apt_house"
        : "lbl_triple_apt_house";
    } else if (val === "aptBulding") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_apt_building").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_apt_building")[0]["value"] ||
          "lbl_apt_building"
          : "lbl_apt_building"
        : "lbl_apt_building";
    } else if (val === "townhouseTwin") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin")[0][
          "value"
          ] || "lbl_townhouse_twin"
          : "lbl_townhouse_twin"
        : "lbl_townhouse_twin";
    } else if (val === "garage") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_garage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_garage")[0]["value"] ||
          "lbl_garage"
          : "lbl_garage"
        : "lbl_garage";
    } else if (val === "summerHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_summer_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_summer_house")[0]["value"] ||
          "lbl_summer_house"
          : "lbl_summer_house"
        : "lbl_summer_house";
    } else if (val === "cotenant") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant")[0]["value"] ||
          "lbl_co_tenant"
          : "lbl_co_tenant"
        : "lbl_co_tenant";
    } else if (val === "hotelGesthouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house")[0][
          "value"
          ] || "lbl_hotel_guest_house"
          : "lbl_hotel_guest_house"
        : "lbl_hotel_guest_house";
    }
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyCb1YPbyCqwlT6XLU83s9UqZViwzEtXRzc",
  });

  // const onLoad = React.useCallback(
  //   (mapInstance) => {
  //     const bounds = new window.google.maps.LatLngBounds();

  //     const boundsIceland = {
  //       north: 66.5902, // Northernmost point
  //       south: 63.255, // Southernmost point
  //       east: -12.0415, // Easternmost point
  //       west: -24.5465, // Westernmost point
  //     };

  //     // Extend the bounds of the map to include Iceland
  //     bounds.extend({ lat: boundsIceland.north, lng: boundsIceland.east });
  //     bounds.extend({ lat: boundsIceland.south, lng: boundsIceland.west });

  //     let loc = new window.google.maps.LatLng(
  //       location?.state?.user?.lat,
  //       location?.state?.user?.lng
  //     );

  //     !propertyLoading &&
  //       property?.length > 0 &&
  //       property
  //         .filter((item) => item.lat  && item.lng)
  //         .forEach((obj) => {
  //           if (location?.state?.user?._id) {
  //             bounds.extend(loc);
  //           } else {
  //             bounds.extend(
  //               new window.google.maps.LatLng(
  //                 parseFloat(obj.lat),
  //                 parseFloat(obj.lng)
  //               )
  //             );
  //           }
  //         });

  //     mapRef.current = mapInstance;
  //     mapInstance.fitBounds(bounds);
  //     mapInstance.panToBounds(bounds);
  //     setViewProp(
  //       property?.find((val) => val._id === location?.state?.user?._id)
  //     );
  //    // mapInstance.defaultCenter = 
  //     //let a = parseFloat(location?.state?.user?.lat);
  //     //let b = parseFloat(location?.state?.user?.lng);
  //     //let d = new window.google.maps.LatLng(a, b);
  //     //var location_place = { lat: a, lng: b };
  //     // console.log(mapRef);
  //      //mapRef?.current?.panTo({lat:64.7707716, lng:-24.5186526 });

  //     // mapRef?.current.setZoom(20);
  //   },
  //   [
  //     location?.state?.user?._id,
  //     location?.state?.user?.lat,
  //     location?.state?.user?.lng,
  //     property,
  //     propertyLoading,
  //   ]
  // );

  const onLoad = React.useCallback(
    (mapInstance) => {
      const bounds = new window.google.maps.LatLngBounds();

      // Define the boundaries of Iceland
      const boundsIceland = {
        north: 66.5902, // Northernmost point
        south: 63.255, // Southernmost point
        east: -12.0415, // Easternmost point
        west: -24.5465, // Westernmost point
      };

      // Extend the bounds of the map to include Iceland
      bounds.extend({ lat: boundsIceland.north, lng: boundsIceland.east });
      bounds.extend({ lat: boundsIceland.south, lng: boundsIceland.west });


      setMap(mapInstance);
   
      var allMarkers = [];
      !propertyLoading &&
      property?.length > 0 &&
      property
        .filter((item) =>  item.lat && item.lng)
        .forEach((item) => (
      
          allMarkers.push(new window.google.maps.Marker({
       
         
            position:{
              lat: parseFloat(item.lat),
              lng: parseFloat(item.lng),
            }
          }
    
          
          ))
        ))
        setCreatedMarkers(allMarkers)
      // Fit the map to the bounds
      mapInstance.fitBounds(bounds);
      mapRef.current = mapInstance;
    },
    []
  );

  //console.log(createdMarkers)

  const onHoverMarker = (id) => {
    setViewProp(property?.find((val) => val._id === id));
    setPropertyId(id)
  };

  const handleLike = () => {
    like(viewProp?._id);
    onHoverMarker(null);
    setPropertyId("")
  };

  const handleUnlike = () => {
    unlike(viewProp?._id);
    onHoverMarker(null);
    setPropertyId("")
  };

  const handleHide = () => {
    hidden(viewProp?._id);
    onHoverMarker(null);
    setPropertyId("")
  };


  

  return (
    <>
      { isLoaded && (
        <GoogleMap
          // mapContainerStyle={containerStyle}
          // ref={(map) => map && map.panTo( c )}
          onLoad={onLoad}
          zoom={13}
          onRightClick={() => {onHoverMarker(null);   setPropertyId("")}}
          mapContainerClassName="containerStyle"
     
        //   defaultZoom={currentZoom}
           onZoomChanged={handleZoomChanged}
           onDragEnd={(e) => onMarkerDragEnd(e)}
        >
          {!propertyLoading &&
            property?.length > 0 &&
            property
              .filter((item) =>  item.lat && item.lng)
              .map((obj) => (
                <Marker
                  key={obj._id}
                  onMouseOver={() => onHoverMarker(obj._id)}
                  position={{
                    lat: parseFloat(obj.lat),
                    lng: parseFloat(obj.lng),
                  }}
                  icon={"http://dev.saturncube.com/property/uploads/newMarkerRed.png"
                   
                  }
                
                />
              ))}

          {viewProp && (
            <InfoWindow
              position={{
                lat: parseFloat(viewProp.lat),
                lng: parseFloat(viewProp.lng),
              }}
              onCloseClick={() => {setViewProp(null); setPropertyId("")}}
            >
              <div className="col-lg-12 col-md-12">
                <div className="view-card-main">
                  <div className="icon-main-view">
                    {viewProp?.favourite === 0 ? (
                      <img
                        src="assets/icons/Favourite.svg"
                        alt="hshshs"
                        onClick={handleLike}
                        style={{
                          cursor: "pointer",
                          width: "32px",
                          height: "32px",
                        }}
                      />
                    ) : (
                      <img
                        src="assets/like.svg"
                        alt="hshshs"
                        onClick={handleUnlike}
                        style={{
                          cursor: "pointer",
                          width: "32px",
                          height: "32px",
                        }}
                      />
                    )}

                    <img
                      src="assets/hidden.svg"
                      alt="hshshs"
                      style={{
                        cursor: "pointer",
                        width: "32px",
                        height: "32px",
                      }}
                      onClick={handleHide}
                    />
                  </div>
                  <Link to={`/property-details/${viewProp._id}`}>
                    <div
                      // className={`${
                      //   allData ? "img-view-main3" : "img-view-main"
                      // }`}
                      className="img-view-main3"
                    >
                      <img
                        src={
                          viewProp.cover_photo
                            ? viewProp.cover_photo
                            : viewProp.photo_gallery[0]
                        }
                        alt="cover_photo"
                        style={{width:'400px'}}
                      />
                    </div>
                    <div className="overlayblack-card">
                      <div className="set-overlay" style={{paddingLeft:"5px",paddingRight:"5px"}}>
                        <p>{`${
                          viewProp.location.length > 45
                            ? viewProp.location.substring(0, 45) + " ..."
                            : viewProp.location
                        }`}</p>
                        <p>{`${viewProp.area}`} </p>
                        <div className="bottom-desc d-flex">
                          <p>
                            {`${getTypeName(viewProp?.propertyType)}, ${
                              viewProp.bhk === "Storage"
                                ? frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_storage"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_storage"
                                      )[0]["value"] || "lbl_storage"
                                    : "lbl_storage"
                                  : "lbl_storage"
                                : viewProp.bhk === "Single Room"
                                ? frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_single_room"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_single_room"
                                      )[0]["value"] || "lbl_single_room"
                                    : "lbl_single_room"
                                  : "lbl_single_room"
                                : viewProp.bhk === "Studio"
                                ? frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_studio"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_studio"
                                      )[0]["value"] || "lbl_studio"
                                    : "lbl_studio"
                                  : "lbl_studio"
                                : `${viewProp?.bhk} ${
                                    frontLabelsName
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_rooms"
                                        ).length > 0
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_rooms"
                                          )[0]["value"] || "lbl_rooms"
                                        : "lbl_rooms"
                                      : "lbl_rooms"
                                  }`
                            }, ${viewProp.size} ㎡ ` ||
                              `${getPropertyType(viewProp.property_type)}, ${
                                viewProp.bhk
                              } rooms`}
                          </p>
                          <p>
                            {viewProp.propertyPrice ||
                              viewProp.property_price ||
                              viewProp.sale_price ||
                              viewProp.pg_price}{" "}
                            kr.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  label: state.language,
});

export default connect(mapStateToProps, {})(MapComponent);
